import styled from "styled-components";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";

export const WorkerCounterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
`;

export const WorkerCounterLabel = styled.span`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue4};
`;

export const WorkerCounterControls = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`;

export const WorkerCounterValue = styled.span`
  ${TypographyV2.h3}
  color: ${ColorV2.Blue1};
  min-width: 18px;
  text-align: center;
`;
